var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M18.5 18.5 21 21M4 6h16M4 12h4m-4 6h4m3-3a4 4 0 1 0 8 0 4 4 0 0 0-8 0"}})])
}
var staticRenderFns = []

export default { render: render }